import React from 'react'
import { getClientSettings } from 'auth/services/auth.service'
import { UserManager } from 'oidc-client'
import { Container, Alert } from 'react-bootstrap'
import { CircleSpinner, logError, CookieType } from 'exports'
import { saveAcceptedToC } from 'auth/constants/termsAndConditions/termsAndConditionsBlock'
import { useTranslation } from 'react-i18next'

function CallbackPage() {
	const [error, setError] = React.useState<Error>()
	const { t } = useTranslation()

	React.useEffect(
		() => {
			signin()
		},
		// eslint-disable-next-line
		[],
	)

	async function signin() {
		const userManager = new UserManager(getClientSettings('query'))

		try {
			if (window.location.search.indexOf('code') === -1) {
				userManager.signinRedirect()
				return
			} else if (window.location.search.indexOf('code') > -1) {
				await userManager.signinCallback()
				await saveAcceptedToC()

				let value =
					sessionStorage.getItem(CookieType.RedirectUrl) ?? '/home'
				window.location.replace(value)
			}
		} catch (error: any) {
			logError(error)
			setError(error)
		}
	}

	return (
		<Container className="spinner-container d-flex justify-content-center align-items-center">
			{error ? (
				<Alert
					variant="danger"
					dismissible
					onClose={() => setError(undefined)}>
					{(error.message.indexOf("iat is in the future") !== -1 || error.message.indexOf("exp is in the past") !== -1) ? t('TimeSyncError') : error.message }
				</Alert>
			) : (
				<CircleSpinner />
			)}
		</Container>
	)
}

export default CallbackPage

